import {Component, Input, OnInit, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'app-modal-select-account2',
  templateUrl: './modal-select-account.component.html',
  styleUrls: ['./modal-select-account.component.css'],
  standalone: false
})
export class ModalSelectAccountComponent implements OnInit {

  @Input() vm: any;

  @Output() selectAccountModalEmit = new EventEmitter<string>();
  @Output() updateAccountEmit = new EventEmitter<string>();

  constructor() {
  }

  ngOnInit() {
  }

  selectAccountModal(accountId) {
    this.selectAccountModalEmit.emit(accountId);
  }

  updateAccount() {
    this.updateAccountEmit.emit();
  }

}
